import Vue from 'vue'
import Vuex from 'vuex'
import i18n from './i18n'
import router from './router'
import JSZip from 'jszip'

Vue.use(Vuex)

var now = new Date()

export default new Vuex.Store({
  state: {
    maintenance: false,
    isMobile: null,
    privacy: false,
    modalPrivacy: false,
    listView: null,
    user: {
      token: null,
      email: '',
    },
    loader: {
      msg: '',
      show: false,
    },
    alert: {
      type: 'error',
      text: '',
      show: false,
    },
    accounts: {
      list: [],
      selected: [],
    },
    date: {
      begin: `${ now.getFullYear() }-${ now.getMonth() - 5 }-01`,
      end: `${now.getFullYear()}-${now.getMonth() + 1}-01`,
    },
    invoices: {
      list: [],
      filtered: [],
      selected: [],
    },
    optionsList: {
      sortBy: ['viewDate'],
      sortDesc: [true],
      itemsPerPage: 6,
    },
    searchList: '',
  },
  mutations: {
    LOGIN (state, data) {
      state.user.token = data.token
      state.user.email = data.user.email
      Vue.prototype.$http.defaults.headers.common.Authorization = 'Bearer ' + data.token
      state.listView = !Vue.prototype.$mobileDetect.phone()
    },
    SET_PRIVACY (state, value) {
      state.privacy = value
    },
    SET_MODAL_PRIVACY (state, value) {
      state.modalPrivacy = value
    },
    LOGOFF (state) {
      state.user.token = null
      state.user.email = null
      state.invoices.list = []
      state.invoices.filtered = []
      state.invoices.selected = []
      state.listView = !Vue.prototype.$mobileDetect.phone()
      delete Vue.prototype.$http.defaults.headers.common.Authorization
      router.push('/')
    },
    SET_EMAIL (state, email) {
      state.user.email = email
    },
    SET_DATE (state, date) {
      state.date.begin = date.begin
      state.date.end = date.end
    },
    SET_BEGIN (state, begin) {
      state.date.begin = begin
    },
    SET_END (state, end) {
      state.date.end = end
    },
    SET_INVOICES (state, invoices) {
      // TODO : Keep filterd by user & selected if always existed in new list
      state.invoices.list = invoices
      state.invoices.filtered = invoices
      state.invoices.selected = []
      state.accounts.list = invoices.map((value) => value.customer.id).filter((value, index, _arr) => _arr.indexOf(value) === index)
      state.accounts.selected = []
    },
    SET_LIST_VIEW (state, bool) {
      state.listView = bool
    },
    SET_MAINTENANCE (state, bool) {
      state.maintenance = bool
    },
    SET_SELECTED_INVOICES (state, list) {
      state.invoices.selected = list
    },
    SET_LOADING (state, { bool, msg }) {
      state.loader.msg = msg
      state.loader.show = bool
    },
    SET_ALERT (state, { bool, type, text }) {
      state.alert = {
        show: bool,
        type: type,
        text: text,
      }
    },
    SET_SELECTED_ACCOUNT (state, accounts) {
      state.accounts.selected = accounts
      if (accounts.length > 0) {
        state.invoices.filtered = state.invoices.list.filter(invoice => state.accounts.selected.indexOf(invoice.customer.id) > -1)
      } else {
        state.invoices.filtered = state.invoices.list
      }
    },
    SET_SEARCH_LIST (state, value) {
      state.searchList = value
    },
    SET_ITEMS_PER_PAGE (state, value) {
      state.optionsList.itemsPerPage = value
    },
  },
  actions: {
    checkApiAccess () {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.post('/get-token', { email: '', password: '' })
          .then((response) => {
            resolve(response)
          })
          .catch(error => {
            if (!error.response || error.response.code !== 503) {
              resolve(error.response)
            } else {
              reject(error)
            }
          })
      })
    },
    login ({ commit, state, dispatch }, credentials) {
      commit('SET_LOADING', { bool: true, msg: i18n.t('loader.connectingInto', { email: state.user.email }) })
      Vue.prototype.$http.post('/get-token', credentials)
        .then((result) => {
          commit('LOGIN', result.data.data)
          router.push('/home')
          dispatch('getInvoices')
        })
        .catch(() => {
          commit('SET_ALERT', { bool: true, type: 'error', text: i18n.t('login.errorCredentials') })
        })
        .then(function () {
          commit('SET_LOADING', { bool: false, msg: '' })
        })
    },
    sendForgotPassword ({ commit, state }) {
      commit('SET_LOADING', { bool: true, msg: i18n.t('loader.sendMail', { email: state.user.email }) })
      Vue.prototype.$http.post('/users/reset-password', { email: state.user.email })
        .then(() => {
          commit('SET_ALERT', { type: 'success', text: i18n.t('login.mailSended') })
        })
        .catch(() => {
          commit('SET_ALERT', { type: 'error', text: i18n.t('login.errorMail', { email: state.user.email }) })
        }).then(() => {
          commit('SET_LOADING', { bool: false, msg: '' })
        })
    },
    sendFirstConnection ({ commit, state }) {
      // TODO : different alert if already done or unknow
      commit('SET_LOADING', { bool: true, msg: i18n.t('loader.sendMail', { email: state.user.email }) })
      Vue.prototype.$http.post('/first-authentication', { email: state.user.email })
        .then((result) => {
          switch (result.status) {
            case 200:
              commit('SET_ALERT', { type: 'success', text: i18n.t('login.mailSended') })
              break
            case 204:
              commit('SET_ALERT', { type: 'error', text: i18n.t('login.firstConnectionAlreadyDone') })
              break
          }
        })
        .catch(() => {
          commit('SET_ALERT', { type: 'error', text: i18n.t('login.errorMail', { email: state.user.email }) })
        })
        .then(() => {
          commit('SET_LOADING', { bool: false, msg: '' })
        })
    },
    updatePassword ({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.put('/users/update-password', data)
          .then((result) => {
            resolve(result)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    newPassword ({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.put('/users/new-password', data)
          .then((result) => {
            resolve(result)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getInvoices ({ commit, state }) {
      const data = {
        dateBegin: state.date.begin,
        dateEnd: state.date.end,
      }
      commit('SET_LOADING', { bool: true, msg: i18n.t('home.getInvoices') })
      Vue.prototype.$http.get('/invoices', { params: data })
        .then((result) => {
          commit('SET_INVOICES', result.data.data)
        })
        .catch(() => {
          commit('SET_ALERT', { type: 'error', text: i18n.t('home.errorGetInvoices') })
        })
        .then(() => {
          commit('SET_LOADING', { bool: false, msg: '' })
        })
    },
    showRecap ({ commit }, id) {
      commit('SET_LOADING', { bool: true, msg: i18n.t('home.showInvoice') })
      Vue.prototype.$http.get('/invoices/ref-porteur?data=' + id)
        .then((response) => {
          const windowReference = window.open()
          const buffer = response.data.data.data
          const content = new Uint8Array(buffer)
          const file = new Blob([content], { type: 'application/pdf' })
          const fileURL = URL.createObjectURL(file)
          windowReference.location = fileURL
        })
        .catch(() => {
          commit('SET_ALERT', { type: 'error', text: i18n.t('home.errorShowRecap') })
        })
        .then(() => {
          commit('SET_LOADING', { bool: false, msg: '' })
        })
    },
    showInvoice ({ commit }, id) {
      commit('SET_LOADING', { bool: true, msg: i18n.t('home.showInvoice') })
      const windowReference = window.open()
      Vue.prototype.$http.get('/invoices/' + id)
        .then((response) => {
          const pdf64 = response.data.data.pdfTo64
          const binary = atob(pdf64.replace(/\s/g, ''))
          const len = binary.length
          const buffer = new ArrayBuffer(len)
          const content = new Uint8Array(buffer)
          for (let i = 0; i < len; i++) {
            content[i] = binary.charCodeAt(i)
          }
          const file = new Blob([content], { type: 'application/pdf' })
          const fileURL = URL.createObjectURL(file)
          windowReference.location = fileURL
        })
        .catch(() => {
          commit('SET_ALERT', { type: 'error', text: i18n.t('home.errorShowInvoice') })
        })
        .then(() => {
          commit('SET_LOADING', { bool: false, msg: '' })
        })
    },
    downloadInvoices ({ commit }, idArray) {
      commit('SET_LOADING', { bool: true, msg: i18n.t('home.downloadInvoices') })
      // TODO : Refactor this actions
      Vue.prototype.$http.get('/invoices/' + idArray)
        .then((response) => {
          if (idArray.length === 1) {
            const pdf64 = response.data.data.pdfTo64
            const binary = atob(pdf64.replace(/\s/g, ''))
            const len = binary.length
            const buffer = new ArrayBuffer(len)
            const content = new Uint8Array(buffer)
            for (let i = 0; i < len; i++) {
              content[i] = binary.charCodeAt(i)
            }
            const file = new Blob([content], { type: 'application/pdf' })
            const fileURL = URL.createObjectURL(file)
            const a = document.createElement('a')
            let name = response.data.data.name
            if (name.indexOf('.pdf') === -1) name += '.pdf'
            a.download = name
            a.href = fileURL
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          } else {
            const zip = new JSZip()
            for (let i = 0; i < response.data.data.length; i++) {
              const encoded = response.data.data[i].pdfTo64
              const binary = atob(encoded.replace(/\s/g, ''))
              const len = binary.length
              const buffer = new ArrayBuffer(len)
              const view = new Uint8Array(buffer)
              for (let i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i)
              }
              let name = response.data.data[i].name
              if (name.indexOf('.pdf') === -1) name += '.pdf'
              zip.file(name, view)
            }
            zip.generateAsync({ type: 'base64' }).then(function (base64) {
              window.location = 'data:application/zip;base64,' + base64
            }, function () {
              commit('SET_ALERT', { type: 'error', text: i18n.t('home.errorDownloadInvoices') })
            })
          }
        })
        .catch(() => {
          commit('SET_ALERT', { type: 'error', text: i18n.t('home.errorDownloadInvoices') })
        })
        .then(() => {
          if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
            commit('SET_ALERT', { type: 'success', text: i18n.t('home.successDownoaldInvoices') })
          }
          commit('SET_LOADING', { bool: false, msg: '' })
        })
    },
    setEmail ({ commit }, email) {
      commit('SET_EMAIL', email)
    },
    setDate ({ commit }, date) {
      commit('SET_DATE', date)
    },
    setBegin ({ commit, dispatch }, begin) {
      commit('SET_BEGIN', begin)
      dispatch('getInvoices')
    },
    setEnd ({ commit, dispatch }, end) {
      commit('SET_END', end)
      dispatch('getInvoices')
    },
    setSelectedInvoices ({ commit }, list) {
      commit('SET_SELECTED_INVOICES', list)
    },
    setMaintenance ({ commit }, bool) {
      commit('SET_MAINTENANCE', bool)
    },
    setLoading ({ commit }, { bool, msg }) {
      commit('SET_LOADING', { bool, msg })
    },
    setAlert ({ commit }, { bool, type, text }) {
      commit('SET_ALERT', { bool, type, text })
    },
    setItemsPerPage ({ commit }, value) {
      commit('SET_ITEMS_PER_PAGE', value)
    },
    setModalPrivacy ({ commit }, value) {
      commit('SET_MODAL_PRIVACY', value)
    },
    setPrivacy ({ commit }, value) {
      commit('SET_PRIVACY', value)
    },
  },
})
